export default __webpack_public_path__ + "static/media/Mark-6-HUD-EEG-EKG Status.20ca0a68.jpg";